(() => {
  if (window.hfDiscoveryProductsListening) return;
  window.hfDiscoveryProductsListening = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-hf-discovery-link]');
    const section = link?.closest('[data-hf-discovery]');
    if (!link || !section || event.defaultPrevented) return;
    const payload = {
      source_page: section.dataset.sourcePage,
      section_id: section.dataset.sectionId,
      link_kind: link.dataset.linkKind,
      product_id: link.dataset.productId || null,
      handle: link.dataset.productHandle || null,
      title: link.dataset.productTitle || null,
      collection_handle: link.dataset.collectionHandle || null,
      url: link.href
    };
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try { window.Shopify.analytics.publish('hitofuri:discovery_product_clicked', payload); } catch {}
    }
  });
})();
